module.exports = "/_next/static/images/4e2d9a8424cd893a27a87e1b596b98f5-nubanker-ds@0.75x.jpg";